import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');

export class FormPreviewComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')

        template.innerHTML = `
                  <div class="card-body p-0">
                      <div class="form-group">
                        <h2 class="text-primary">` + name + `</h2>
                        <div class="font-weight-light preview-value col-12 col-md-6 p-0">-</div>
                      </div>
                  </div>`

        initWebComponent(this, template)
    }
}
